import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CellComponent } from '@spartacus/organization/administration/components';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';
import { JoinByPipe } from '../../../shared/pipes/join-By.pipe';
import { UrlPipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-list-cell',
    templateUrl: './efa-list-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, NgTemplateOutlet, JoinByPipe, UrlPipe]
})
export class EfaListCellComponent extends CellComponent {
}
